import PropTypes from 'prop-types';

import { SelectedColorLabel, SelectedColorName, ColorDescription } from './styles';

const ColorInfo = ({ selectedSwatch }) => (
  <div>
    <SelectedColorLabel>Color Selected: </SelectedColorLabel>
    <SelectedColorName>{selectedSwatch.name}</SelectedColorName>
    {selectedSwatch.description && <ColorDescription>{selectedSwatch.description}</ColorDescription>}
  </div>
);

ColorInfo.propTypes = {
  selectedSwatch: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default ColorInfo;
